import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex h-full flex-col gap-5 pt-10 pb-10 sm:gap-10 sm:pt-20 md:gap-15 md:pt-30',
    dialogContent: 'p-0!',
    imagesCarousel:
      'xs:[--slide-size:400px] xs:[--slide-spacing:20px] flex grow-1 items-center [--slide-size:100vw] [--slide-spacing:0px] sm:[--slide-size:500px]',
    thumbnailsCarousel:
      'self-center [--slide-size:80px] [--slide-spacing:8px] max-sm:w-full'
  }
});

export const baseCarouselStyles = tv({
  slots: {
    viewport: 'overflow-hidden',
    carousel:
      'ml-[calc(var(--slide-spacing)*-1)] flex touch-pan-y touch-pinch-zoom',
    slideContainer: 'shrink-0 pl-[var(--slide-spacing)]',
    slide: 'aspect-square w-[var(--slide-size,auto)]',
    slideButton: 'cursor-pointer opacity-50'
  },
  variants: {
    active: {
      true: {
        slideButton: 'opacity-100'
      }
    }
  }
});
